<mat-card class="filter settingHeader">
  <div class="name">
    Form Use Report
  </div>

  <div class="projectSearch">
      
    <button class="searchbtn" [disabled]="value==''"  mat-icon-button aria-label="Clear">
      <mat-icon (click)="SearchFilter()">search</mat-icon>
    </button>
   
    <input placeholder="Search" type="text"  maxlength="50" [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" />
   
    <button class="filterbtn" mat-icon-button (click)="applyAdvFilter(advFilter)"
    matTooltipClass="tooltip" matTooltip="Filters">
   <mat-icon>filter_list</mat-icon>
  </button>
 

 </div>


  <!-- <div class="quickAction">
    <mat-form-field class="example-form-field" appearence="fill">
      <mat-label>Search Record</mat-label>
      <input matInput type="text"  [(ngModel)]="value" (keyup)="$event.keyCode == 13 ? Search($event.target.value) : ($event.target.value==''?Search($event.target.value):null)" >
      <button mat-button *ngIf="value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>close</mat-icon>
      </button>
      <button  *ngIf="!value" matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
        <mat-icon>search</mat-icon>
      </button>
    </mat-form-field>
   
  </div> -->

</mat-card>

<mat-card class="documents">
  <table class="mat-table" *ngIf="!ShowNoRecordFound">
    <thead>
      <tr class="mat-header-row">
        <!-- <th class="mat-header-cell">SNo</th> -->
        <th class="mat-header-cell">Form Name</th>
        <th class="mat-header-cell">Form Type</th>
        <th class="mat-header-cell">Office Name</th>
        <th class="mat-header-cell">Owner</th>       
        <th class="mat-header-cell">Create Date</th>
        <th class="mat-header-cell">Projects Count</th>
        <th class="mat-header-cell">SignNow Projects Count</th>    
        <th class="mat-header-cell">{{CoreShowName}} Placeholders</th> 
        <th class="mat-header-cell">Total Count</th>      
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let temp of aITemplateList; let i = index" class="mat-row" >
        <!-- <td class="mat-cell">{{ i + 1 }}</td> -->
        <td class="mat-cell" matTooltip="{{temp.formName}}" matTooltipClass="tooltip"><p>{{ temp.formName }}</p></td>
        <td class="mat-cell">             
          <p *ngIf="temp.formType==1">PDF Form</p>
          <p *ngIf="temp.formType==2">Tabular Form</p> 
          <p *ngIf="temp.formType==3">Web Form</p> 
        </td> 
        <td class="mat-cell" matTooltip="{{temp.officeName}}" matTooltipClass="tooltip"><p>{{ temp.officeName }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.fullName}}" matTooltipClass="tooltip"><p>{{ temp.fullName }}<br>{{ temp.email }}</p></td>
        <!-- <td class="mat-cell" matTooltip="{{temp.email}}" matTooltipClass="tooltip"><p>{{ temp.email }}</p></td> -->
        <td class="mat-cell" matTooltipClass="tooltip"><p>{{ temp.createdOn | date: "MM/dd/yyyy" }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.projectsCount}}" matTooltipClass="tooltip"><p>{{ temp.projectsCount }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.signNowProjectsCount}}" matTooltipClass="tooltip"><p>{{ temp.signNowProjectsCount }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.corePlaceholderCount}}" matTooltipClass="tooltip"><p>{{ temp.corePlaceholderCount }}</p></td>
        <td class="mat-cell" matTooltip="{{temp.totalCount}}" matTooltipClass="tooltip"><p>{{ temp.totalCount }}</p></td>
      </tr>
    </tbody>
  </table>
  <div *ngIf="ShowNoRecordFound" class="noRecordFound">No Record Found</div>
</mat-card>


<ng-template #advFilter>

  <h2 mat-dialog-title>
    <span class="groupIcon">
      <mat-icon>view_column</mat-icon>
    </span>
     Search
    <button mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>   
  </h2>

  <mat-dialog-content class="mat-typography">

    <div class="allheaders">    
      
      <mat-form-field appearance="" *ngIf="showSuperAdmin==true">
        <mat-label>Organization Name</mat-label>
        <mat-select placeholder = "Select Organization"  
          (selectionChange)="getOffice($event)">
           <mat-option *ngFor = "let data of OrgnizationList" 
              [value] = "data.organizationID">
              {{data.organizationName}}
           </mat-option>
        </mat-select>
      </mat-form-field> 

      <mat-form-field appearance="" *ngIf="showOrganizationAdmin==true">
        <mat-label>Office Name</mat-label>
        <mat-select placeholder = "Select Office"  [(ngModel)]="selectedOfficeId" (selectionChange)="selectOffice($event)">
          <mat-option *ngFor = "let data of OrgOfficeList" 
             [value] = "data.officeID">
             {{data.officeName}}
          </mat-option>
       </mat-select>
      </mat-form-field> 

      <mat-form-field appearance="" *ngIf="showUserAdmin==true">
        <mat-label>User Name</mat-label>
        <mat-select placeholder = "Select User" [(ngModel)]="selecteduserId"  (selectionChange)="selectUser($event)">
          <mat-option *ngFor = "let data of UsersList" 
             [value] = "data.uuid">
             {{data.firstName}} {{data.lastName}} 
          </mat-option>
       </mat-select>
      </mat-form-field>       
         
    </div>

  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-flat-button class="calltoaction" type="submit"             
    (click)="SearchFilter()" color="primary">
       Search
      <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
      </mat-spinner></mat-icon>
    </button>

    <button mat-flat-button class="calltoaction" type="submit"             
    (click)="clear()" color="primary">
      Clear      
    </button>

  </mat-dialog-actions>

</ng-template>

<app-loader></app-loader>